import { Component, Input } from '@angular/core';
import { GeneralInfoItem } from 'src/app/models/device.model';

@Component({
  selector: 'app-general-device-info',
  templateUrl: './general-device-info.component.html',
  styleUrl: './general-device-info.component.scss',
  standalone: false,
})
export class GeneralDeviceInfoComponent {
  @Input() generalInfoItems: GeneralInfoItem[] = [];

  get rows(): GeneralInfoItem[] {
    return (this.generalInfoItems ?? []).filter(
      (item) => !!item.label?.trim() || !!item.value?.trim(),
    );
  }
}
